import { FC, useState } from "react";
import { AcceptableNamedRow } from "../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/AcceptableNamedRow";
import { CollapsedFields } from "../../../components/GeneralUI/CollapsedFields/CollapsedFields";
import { NamedNumberic } from "../../../ui/layout/molecules/NamedNumberic";
import { parseNumberOrZero } from "../../../helpers";
import { boostingLimitNumberProps } from "../constants";

export const LimitNumberField: FC<{
  rowTitle: string;
  switchTitle: string;
  numberTitle: string;
  value?: number;
  onAccept: (value: number) => Promise<boolean>;
  permissionsGroup: string;
}> = ({
  rowTitle,
  switchTitle,
  numberTitle,
  value = 0,
  onAccept,
  permissionsGroup,
}) => {
  const [draft, setDraft] = useState(value);

  return (
    <AcceptableNamedRow
      title={rowTitle}
      permissionsGroup={permissionsGroup}
      content={value || "Disabled"}
      initConfig={() => setDraft(value)}
      allowSubmit={draft !== value}
      onSubmit={() => onAccept(draft)}
    >
      <CollapsedFields
        title={switchTitle}
        active={draft > 0}
        activateFields={() => setDraft(value ? value : 1)}
        resetFields={() => setDraft(0)}
      >
        <NamedNumberic
          title={numberTitle}
          value={draft}
          onChange={(target) => setDraft(parseNumberOrZero(target.value))}
          {...boostingLimitNumberProps}
        />
      </CollapsedFields>
    </AcceptableNamedRow>
  );
};
